/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminBrigade
 */
export interface InputAdminBrigade {
    /**
     * 
     * @type {string}
     * @memberof InputAdminBrigade
     */
    name: string;
}

/**
 * Check if a given object implements the InputAdminBrigade interface.
 */
export function instanceOfInputAdminBrigade(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputAdminBrigadeFromJSON(json: any): InputAdminBrigade {
    return InputAdminBrigadeFromJSONTyped(json, false);
}

export function InputAdminBrigadeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminBrigade {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function InputAdminBrigadeToJSON(value?: InputAdminBrigade | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

